import { render, staticRenderFns } from "./std-form.vue?vue&type=template&id=c9d40b0a&scoped=true&"
import script from "./std-form.ts?vue&type=script&lang=ts&"
export * from "./std-form.ts?vue&type=script&lang=ts&"
import style0 from "./std-form.scss?vue&type=style&index=0&id=c9d40b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d40b0a",
  null
  
)

export default component.exports